module.exports = __webpack_public_path__ + "img/solution2_chart2.93452048.png";